<template>
  <div class="nprogress-container" />
</template>

<script>
export default {
  name: 'nprogress-container'
}
</script>
